import axios from '@/libs/api.request'

export const getProductReferencePluginData = (plugin, productId) => {
  return axios.request({
    method: 'get',
    url: `products/${productId}/plugins`,
    params: { plugin: plugin }
  })
}

export const setProductReferencePluginData = (plugin, productId, data) => {
  return axios.request({
    url: `products/${productId}/plugins`,
    method: 'post',
    params: { plugin: plugin },
    data
  })
}

export const deleteProductReferencePluginData = (plugin, productId, data) => {
  return axios.request({
    url: `products/${productId}/plugins`,
    method: 'delete',
    params: { plugin: plugin },
    data
  })
}
